<div class="modal" id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="modal-body">
				<ng-content></ng-content>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm">
							<button class="btn btn-warning me-4" (click)="deleteOpen()">
								<span *ngIf="deleteType === 'archive'"><i class="fas fa-archive"></i> Archiwizuj</span>
								<span *ngIf="deleteType === 'delete'"><i class="far fa-trash-alt"></i> Usuń</span>
							</button>
						</div>
						<div class="col-sm text-end">
							<button type="button" class="btn btn-primary me-4" (click)="submit()">Zapisz</button>
							<button
								type="button"
								class="btn btn-secondary"
								data-bs-dismiss="modal"
								(click)="dialogClose()"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
